import { z } from 'zod';
import { projectConfigSchema } from '../schemas/projectConfig';

export type ProjectConfig = z.infer<typeof projectConfigSchema>;

export function useProjectConfig(): ProjectConfig {
  const config = useRuntimeConfig();
  return config.public.project as ProjectConfig;
}
